import { CSSProperties } from 'react';

// Returns a consistent compact row style used across dashboard mini-lists
export function getCompactRowStyle(accentColor?: string): CSSProperties {
  const color = accentColor || 'gray';
  return {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    padding: '4px 6px',
  border: `1px solid var(--mantine-color-${color}-3)`,
  borderRadius: 6,
  background: 'var(--row-bg, var(--mantine-color-gray-0))',
  // Dark mode override is applied via global CSS selector: 
  // [data-mantine-color-scheme='dark'] [data-dark-style] { background: var(--row-bg, var(--mantine-color-dark-6)); }
  // We intentionally do NOT set --row-bg / --row-border here so light mode stays light.
  position: 'relative'
  };
}
